import * as React from "react";
import { Form } from "semantic-ui-react";
import { toast } from "@teamprevent/common/toasts";

interface OwnProps {
    fileName?: string;
    onFileChange: (file: File) => void;
    acceptExtensions?: string[];
}

export default class FileImport extends React.Component<OwnProps> {
    private fileInput: HTMLInputElement;

    constructor(props: OwnProps) {
        super(props);

        this.componentDidUpdate = this.componentDidUpdate.bind(this);

        this.handleFileChange = this.handleFileChange.bind(this);
        this.fileInputClick = this.fileInputClick.bind(this);
    }

    public componentDidUpdate(prevProps: OwnProps) {
        if (prevProps.fileName && !this.props.fileName) {
            this.fileInput.value = "";
        }
    }

    public render() {
        return (
            <div>
                <input
                    type="file"
                    accept={this.props.acceptExtensions && this.props.acceptExtensions.join(",")}
                    onChange={this.handleFileChange}
                    ref={input => this.fileInput = input}
                    hidden
                    className="file-import-input"
                />
                <Form.Button
                    type="button"
                    content={"Select"}
                    onClick={this.fileInputClick}
                    value={this.props.fileName}
                />
            </div>
        );
    }

    private fileInputClick() {
        this.fileInput.click();
    }

    private async handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
        const file = event.target.files[0];

        const validExtensions = this.props.acceptExtensions;
        if (validExtensions && !validExtensions.some(ext => file.name.toUpperCase().endsWith(ext.toUpperCase()))) {
            toast.error(`File extension must be one of ${this.props.acceptExtensions.join(", ")}`);
            return;
        }

        this.props.onFileChange(file);
    }
}
